import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SettingsIcon from '@mui/icons-material/Settings';
import EstadoModo from './EstadoModo';

const headerCellSx = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.78rem',
  textTransform: 'uppercase',
  letterSpacing: 0.3,
  bgcolor: 'grey.50',
};

const TablaTerminales = ({
  data,
  total,
  loading,
  error,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onConfigurar,
}) => {
  if (error) {
    return <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>{error}</Alert>;
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
      <TableContainer sx={{ position: 'relative', minHeight: 220 }}>
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.7)',
              zIndex: 1,
            }}
          >
            <CircularProgress size={32} />
          </Box>
        )}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>ID Terminal</TableCell>
              {/* <TableCell sx={headerCellSx}>Store ID</TableCell> */}
              {/* <TableCell sx={headerCellSx}>POS ID</TableCell> */}
              <TableCell sx={headerCellSx}>External POS ID</TableCell>
              <TableCell sx={headerCellSx}>Modo de Operación</TableCell>
              <TableCell sx={{ ...headerCellSx, textAlign: 'center' }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 1,
                      py: 6,
                      color: 'text.secondary',
                    }}
                  >
                    <PointOfSaleIcon sx={{ fontSize: 40, opacity: 0.4 }} />
                    <Typography variant="body2">No hay terminales para mostrar</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              data.map((terminal) => (
                <TableRow key={terminal.id} hover>
                  <TableCell sx={{ wordBreak: 'break-all', fontSize: '0.82rem' }}>{terminal.id}</TableCell>
                  {/* <TableCell sx={{ fontSize: '0.82rem' }}>{terminal.store_id}</TableCell>
                  <TableCell sx={{ fontSize: '0.82rem' }}>{terminal.pos_id}</TableCell> */}
                  <TableCell sx={{ fontSize: '0.82rem' }}>{terminal.external_pos_id}</TableCell>
                  <TableCell>
                    <EstadoModo mode={terminal.operating_mode} />
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<SettingsIcon fontSize="small" />}
                      onClick={() => onConfigurar(terminal)}
                    >
                      Configurar
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={total}
        page={page}
        rowsPerPage={pageSize}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
};

export default TablaTerminales;
